<template>
    <div>
        <b-modal v-model="isModalVisible" hide-footer :close-on-backdrop="false" class="pt-8" centered header-class="p-0"
            footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
            <template #modal-title>
                <div class="title-block text-center p-2">
                    {{ model.id ? $translate('view_message') : $translate('add_message') }}
                </div>
            </template>
            <div v-if="!!model.id">
                <label class="mb-3"><strong>{{ $translate('received') }}</strong></label><br>
                {{ model.created_at | displayTime }}
            </div>
            <div v-if="!!model.id">
                <label class="mb-3 mt-3"><strong>{{ $translate('sender') }}</strong></label><br>
                {{ displayUser(model.user) }}
            </div>
            <div class="mb-3 mt-3">
                <label class="mb-3"><strong>{{ $translate('message') }}</strong></label>
                <textarea class="form-control" :disabled="!!model.id" id="input-content" v-model="model.content"
                    :placeholder="$translate('enter_message')" rows="6" max-rows="10"></textarea>
            </div>
            <b-button id="create-note-btn" v-show="!model.id" size="fw" class="me-3" @click="createNote" :disabled="submitting ? true : false"
                variant="info">{{ submitting ? $translate('adding_message') : $translate('add_message') }}</b-button>
            <b-button id="close-note-btn" size="fw" @click="isModalVisible = false" variant="info">{{ $translate('close') }}</b-button>
        </b-modal>
        <div class="d-flex align-items-center justify-content-end">
            <span class="me-2">{{ $translate('add_message') }}</span>
            <div class="Click-here"></div>
            <b-button id="add-new-note-btn" variant="blue-icon" @click=" 
                model.content = ''
            model.id = null
            isModalVisible = true
                "><img src="@/assets/images/icon/gradient-add.svg"></b-button>
        </div>
        <div class="table-responsive">
            <table class="table b-table" id="orderTable" :style="customColor">
                <thead :style="customColor">
                    <th v-for="item in fields" :key="item.id" :class="item.class">{{ item.label }}</th>
                </thead>
                <tbody :style="customColor">
                    <tr v-if="tableLoading">
                        <td colspan="99">
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(item, index) in messages" :key="item.id">
                        <td class="id_class">
                            {{ index + 1 }}
                        </td>
                        <td class="actionButton_class">
                            <div class="d-flex gap-1 justify-content-start">
                                <b-button  variant="pink-button" @click="viewNote(item)" :id="'view-note-btn-'+index" class="me-2 test-view-note-btn">
                                    <img src="@/assets/images/icon/view.svg">
                                </b-button>
                                <!-- <b-button variant="pink-button" @click="deleteNote(item.id)"
                                    :disabled="submitting ? true : true">
                                    <img
                                        src="@/assets/images/icon/delete.svg"></b-button> -->
                                <!-- <b-button size="sm" @click="viewNote(item)" class="mr-2" variant="primary">
                                View
                            </b-button>
                            <b-button size="sm" variant="warning" @click="deleteNote(item.id)" :disabled="submitting ? true : false">{{
                                'Delete' }}</b-button>-->
                            </div>
                        </td>
                        <td class="user_id_class">{{ displayUser(item.user) }}</td>
                        <td class="text-left text-wrap">{{ item.content }}</td>
                        <td class="created_at_class">{{ item.created_at | displayTime(true) }}</td>
                        
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
// import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'notes',
    mixins: [popupMixins],
    props: {
        order: {
            type: Object,
            default() {
                return {
                    notes: [
                        {
                            id: 0,
                            content: '',
                        },
                    ],
                }
            },
        },
    },
    data() {
        return {
            model: {},
            isModalVisible: false,
            tableLoading: false,
            submitting: false,
        }
    },
    filters: {
        displayTime(date) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            console.log('timezone', timezone)
            if (date) {
                return new Date(date).toLocaleString('en-US', {
                    timeZone: timezone,
                })
            } else {
                return ''
            }
        },

    },
    computed: {
        componentName() { return this.$translate('service_message') },
        fields() {
            return [
                {
                    key: 'id',
                    label: '',
                    class: 'id_class',
                },
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                    class: 'actionButton_class',

                },
                {
                    key: 'user_id',
                    label: this.$translate('sender'),
                    class: 'user_id_class',

                },
                {
                    key: 'content',
                    label: this.$translate('messages'),
                    class: 'w-50 text-center',
                },

                {
                    key: 'created_at',
                    label: this.$translate('received'),
                    class: 'created_at_class',
                },
               
            ]
        },
        emptyText() {
            return `<h4>${this.$translate('add_message_note')}</h4>`
        },

        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + "!important",
                color: data.text_color + "!important"
            }
            return colors
        },
        messages() {
            const notes = this.order.notes || []
            console.log('notes', notes)
            return notes
        },
    },
    methods: {
        displayUser(user) {
            const name = user.first_name + ' ' + user.last_name
            return (user.is_customer_user ? this.$translate('client') : this.$translate('agent')) + ':' + name
        },
        viewNote(item) {
            for (const key in item) {
                this.$set(this.model, key, item[key])
            }
            this.isModalVisible = true
        },
        createNote() {
            const { content } = this.model
            this.submitting = true
            const order_id = this.order.id
            this.$store
                .dispatch('customerPortal/createNote', { order_id, content })
                .then(() => {
                    this.$store.dispatch(
                        'customerPortal/fetchOrder',
                        this.order.id
                    )
                 
                    this.genericToast(
                        this.componentName,
                        this.$translate('added'),
                        'success',
                        `${this.$translate('added_alert')}`
                    )
                    // this.doToast('Sent!', 'Message Added!', 'success')
                    this.isModalVisible = false
                })
                .catch(error => {
                    console.error(error)
                    this.doToast(this.$translate('error'), this.$translate('adding_error'), 'danger')
                })
                .finally(() => {
                    this.submitting = false
                })
        },

        deleteNote(note_id) {
            const title = `${this.$translate('delete')} ${this.componentName}?`
            const message = `${this.$translate('delete_note')} ${this.componentName}?`
            this.confirmMessage(title, message).then(result => {
                if (!result) return
                const order_id = this.order.id
                this.submitting = true
                this.$store
                    .dispatch('customerPortal/deleteNote', {
                        order_id,
                        note_id,
                    })
                    .then(() => {
                        this.$store.dispatch(
                            'customerPortal/fetchOrder',
                            this.order.id
                        )

                        this.genericToast(
                            this.componentName,
                            this.$translate('deleted'),
                            'success',
                            `${this.componentName} ${this.$translate('delete_alert')}`
                        )
                    })
                    .catch(error => {
                        console.error(error)
                        this.doToast(this.$translate('error'), this.$translate('delete_error'), 'danger')
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
    },
}
</script>

<style lang="scss" scoped></style>
